<template>
	<div ref="observerTarget">
		<slot></slot>
	</div>
</template>

<script>
import Jet from '@/modules/Jet'

export default {
	name: 'BlockVisibilityObserver',
	emits: ['hide', 'show'],

	props: {
		// eslint-disable-next-line vue/require-default-prop
		title: {
			type: String,
		},

		path: {
			type: Array,
			default: () => [],
		},

		eventParams: {
			type: Object,
			default: () => ({}),
		},

		rootMargin: {
			type: String,
			default: '0px',
		},

		threshold: {
			type: [Number, Array],
			default: 0,
		},
	},

	data() {
		return {
			isAnalyticsEventSent: false,
		}
	},

	mounted() {
		this._observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => this.onChange(entry))
			},
			{
				rootMargin: this.rootMargin,
				threshold: this.threshold,
			},
		)
		this._observer.observe(this.$refs.observerTarget)
	},

	beforeUnmount() {
		if (this._observer) {
			this._observer.disconnect()
			this._observer = null
		}
	},

	methods: {
		async onChange(entry) {
			if (entry.isIntersecting) {
				this.$emit('show', entry)

				if (!this.isAnalyticsEventSent && entry.intersectionRatio >= 1) {
					this.$analytic.logEvent('BlockView', {
						title: this.title,
						path: this.path,
						...this.eventParams,
					})

					const titleEnumExists = await Jet.titleEnumExists(this.title)
					if (titleEnumExists) {
						Jet.logUxEvent('BlockView', { title: this.title })
					}

					this.isAnalyticsEventSent = true
				}
			} else {
				this.$emit('hide', entry)
			}
		},
	},
}
</script>
